import React from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';
import EmptyIconWithText from 'components/Widgets/EmptyIconWithText';

export default function Index({
  member, link, bigIcon, contentClassName, wrapperClassName, children,
}) {
  const size = bigIcon ? '64px' : '40px';

  if (member === null) {
    return (
      <EmptyIconWithText
        size={size}
        contentClassName={contentClassName}
        wrapperClassName={wrapperClassName}
      >
        <div className="mb-1 small fw-light text-gray-700">Member</div>

        <div className="fw-semibold">
          -
        </div>
      </EmptyIconWithText>
    );
  }

  const content = children || (
    <>
      <div className="mb-1 small fw-light text-gray-700">Member</div>

      <div className="fw-semibold text-gray-900">
        {member.full_name}
      </div>
    </>
  );

  const icon = (
    <>
      {member.avatar_url ? (
        <IconWithText
          iconClassName={`picture-icon ${bigIcon ? 'big-icon' : ''} rounded-circle`}
          iconStyle={{ backgroundImage: `url(${member.avatar_url})` }}
          contentClassName={contentClassName}
          wrapperClassName={wrapperClassName}
        >
          {content}
        </IconWithText>
      ) : (
        <EmptyIconWithText
          size={size}
          contentClassName={contentClassName}
          wrapperClassName={wrapperClassName}
        >
          {content}
        </EmptyIconWithText>
      )}
    </>
  );

  return (
    <>
      {link ? (
        <a href={link} className="text-decoration-none">
          {icon}
        </a>
      ) : (
        <>
          {icon}
        </>
      )}
    </>
  );
}

Index.propTypes = {
  member: PropTypes.object,
  link: PropTypes.string,
  bigIcon: PropTypes.bool,
  contentClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  children: PropTypes.node,
};

Index.defaultProps = {
  member: null,
  link: null,
  bigIcon: true,
  contentClassName: '',
  wrapperClassName: '',
  children: null,
};
